import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Award = createReactComponent("Award", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "8",
  r: "7",
  key: "1a1y5i"
}], ["polyline", {
  points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88",
  key: "1lk7zz"
}]]]);
export default Award;